import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';

import * as Api from '../../../api/api';

export const updateSurveyResponse = (
  surveyResponseId: number,
  body: {
    manualResponse?: string;
    isRelevant?: boolean;
  },
  employeeId?: number | string,
) =>
  createGenericDispatcher<SurveyResponse>({
    name: 'UPDATE_SURVEY_RESPONSE',
    loadFunction: () =>
      Api.post(`/survey-responses/${surveyResponseId}`, {
        body: JSON.stringify(body),
      }),
    args: { surveyResponseId, employeeId, body },
  });
